import { render, staticRenderFns } from "./CenterMap.vue?vue&type=template&id=b8f3cd38&scoped=true"
import script from "./CenterMap.vue?vue&type=script&lang=js"
export * from "./CenterMap.vue?vue&type=script&lang=js"
import style0 from "./CenterMap.vue?vue&type=style&index=0&id=b8f3cd38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8f3cd38",
  null
  
)

export default component.exports